<div class="dialog-wrap">
  <h3>{{ "GENIUS_SETTINGS.DISCONNECT_CARE_TITLE" | translate }}</h3>
  <p>{{ "GENIUS_SETTINGS.DISCONNECT_CARE_TEXT" | translate:{ device: tenant.current.deviceName } }}</p>
  <button mat-raised-button color="primary" (click)="close()">{{ "GENIUS_SETTINGS.DISCONNECT_CARE_CLOSE" | translate }}</button>
</div>
